module.exports = __webpack_public_path__ + "img/swiper1.f9590495.jpg";